import { RelevanceTier } from '@api/api/event-feed';
import { TFunction } from 'i18next';

const TIER_TRANSLATION_KEY: Record<RelevanceTier, string> = {
  1: 'stream:relationPill.first',
  2: 'stream:relationPill.second',
  3: 'stream:relationPill.third',
};

export const getTierRelationText = (
  tier: RelevanceTier,
  t: TFunction
): string => t(TIER_TRANSLATION_KEY[tier]);
